import { useContext, useEffect } from 'react';
import { ModalContext } from './ModalContext.js';
import { useAnimationFrame } from '../../../hooks/useAnimationFrame/useAnimationFrame.js';
import 'wretch';
import 'wretch/addons/queryString';
import '../../../utils/mParticle/mParticle.js';
import 'fromentries';

const useDetectModalBodyScroll = (ref) => {
    const { setIsBodyScrolled } = useContext(ModalContext);
    const handleScroll = useAnimationFrame(() => {
        if (ref.current && ref.current.scrollTop > 0) {
            setIsBodyScrolled(true);
        }
        else {
            setIsBodyScrolled(false);
        }
    }, []);
    useEffect(() => {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', handleScroll);
        return () => {
            var _a;
            setIsBodyScrolled(false);
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
};

export { useDetectModalBodyScroll };
//# sourceMappingURL=useDetectModalBodyScroll.js.map
